import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 1rem 0;

  .subHeader {
    display: flex;
    align-items: flex-end;

    h1 {
      color: ${({ theme }) => theme.colors.tertiary_500};
      font-size: 22px;
      margin: 0;
      width: 100%;
      font-weight: medium;
      margin-left: 0.5rem;
    }

    svg {
      width: 1.8rem;
      height: 1.8rem;
      fill: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  margin: 0 auto 1rem;

  .containerDataSolicitation {
    display: flex;
    margin: 1rem 0;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.background_white};
    border-radius: 1rem;

    h2 {
      font-size: 1.5rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary};
    }

    .contentDate {
      display: flex;
      align-items: center;
      margin-top: 0.5rem;
      gap: 2rem;

      .MuiOutlinedInput-root {
        text-align: center;

        fieldset {
          border: none;
          border-radius: 0;
          border-bottom: 2px ${({ theme }) => theme.colors.primary} solid;
        }

        :hover {
          fieldset {
            border-bottom: 2px black solid;
          }
        }
      }

      .MuiInputBase-input {
        padding: 0.3rem 0 0 0;
        font-family: 'Futura PT';
        font-weight: 350;
        font-size: 1.2rem;
      }

      .time {
        width: 41%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: end;
        gap: 1rem;
        .dropdownTime {
          width: 14%;
        }
      }

      h3 {
        font-size: 22px;
        font-weight: 300;
        color: ${({ theme }) => theme.colors.secondary};
      }
    }
  }

  .title {
    font-size: 1.2rem;
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: 450;
  }

  .content-map-date {
    display: flex;
    column-count: 3;
    width: 100%;
    justify-content: space-between;
    gap: 1rem;
    max-height: 4rem;
    overflow-y: auto;

    .header-table {
      width: 100%;
      font-weight: lighter;
      color: ${({ theme }) => theme.colors.text_gray};
    }

    .item-in-table {
      width: 100%;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.primary};
    }

    ::-webkit-scrollbar {
      width: 8px;
      background-color: ${({ theme }) => theme.colors.background_white};
      border-radius: 10px;
    }

    ::-webkit-scrollbar:horizontal {
      height: 5px;
    }

    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-horizontal {
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:horizontal {
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      border-radius: 10px;
    }
  }

  @media (max-width: 450px) {
    .containerDataSolicitation .contentDate {
      flex-direction: column;

      .MuiFormControl-root {
        width: 100%;
      }

      .time {
        width: 100%;
        justify-content: center;

        .dropdownTime {
          width: 100%;
        }
      }
    }
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
